const initialState = {
  channels: [],
  posts: {},
  users: {},
  typingUsers: [],
  successStep: "",
  // Newest post per channel, keyed by channel id. Backs the group list preview
  // without having to hold every channel's full history.
  lastPosts: {},
  // Unread count per channel, keyed by channel id. Backs the bold/badge state
  // in the group list.
  unreadCounts: {},
  // The channel currently open on screen, if any. An incoming post for THIS
  // channel does not bump its own unread count -- the user is already looking
  // at it.
  activeChannelId: null,
};

const ChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_MM_CHANNELS":
      return { ...state, channels: action.payload };
    case "USER_MM_CHANNEL_POSTS":
      const { channelId, posts } = action.payload;
      state.posts[channelId] = posts;
      return { ...state };
    case "CREATE_CHANNEL_SUCCESS":
      return { ...state, channels: [...state.channels, action.payload], successStep: "channel_created" };
    case "REMOVE_STEP_MSG": {
      return {...state, successStep: ""}
    }
    case "USER_MM_LAST_POSTS":
      return { ...state, lastPosts: { ...state.lastPosts, ...action.payload } };
    case "USER_MM_UNREAD_COUNTS":
      return { ...state, unreadCounts: { ...state.unreadCounts, ...action.payload } };
    case "USER_MM_CLEAR_UNREAD":
      return {
        ...state,
        unreadCounts: { ...state.unreadCounts, [action.payload.channelId]: 0 },
      };
    case "USER_MM_ACTIVE_CHANNEL":
      return { ...state, activeChannelId: action.payload };
    case "USER_MM_NEW_POST": {
      const { channelId, post } = action.payload;
      const existsPosts = { ...state.posts[channelId] };
      // check post.id in existsPosts.order to avoid duplicate
      if((existsPosts.order || []).includes(post.id)){
        return state;
      }
      const newOrder = [post.id, ...(existsPosts.order || [])];

      const newPosts = {
        ...existsPosts.posts,
        [post.id]: post
      };
      const previousLast = state.lastPosts[channelId];
      // The channel currently open on screen has already seen this message
      // arrive, so it never bumps its own badge.
      const isActiveChannel = channelId === state.activeChannelId;
      return {
        ...state,
        posts: {
          ...state.posts,
          [channelId]: {
            ...existsPosts,
            order: newOrder,
            posts: newPosts
          }
        },
        // Keep the list preview current as messages arrive, so a group's row
        // updates live without re-fetching.
        lastPosts:
          !previousLast || post.create_at >= previousLast.create_at
            ? { ...state.lastPosts, [channelId]: post }
            : state.lastPosts,
        unreadCounts: isActiveChannel
          ? state.unreadCounts
          : { ...state.unreadCounts, [channelId]: (state.unreadCounts[channelId] || 0) + 1 },
      };
    }
    case "USER_MM_USERS":
      const users = action.payload;
      if (users) {
        users.forEach((user) => {
          state.users[user.id] = user;
        });
        return { ...state };
      } else {
        return state;
      }
    case "USER_MM_TYPING":
      const { userId } = action.payload;
      return { ...state, typingUsers: [...state.typingUsers, userId] };
    case "USER_MM_TYPING_RESET":
      return { ...state, typingUsers: [] };
    default:
      return state;
  }
};

export default ChatReducer;
